import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import RootModal from "../components/modals/RootModal";
import * as actions from "../constants/actions";
import { MODAL_TYPES } from "../constants/modals";

const mapStateToProps = state => ({
  modalType: state.modals.modalType,
  modalProps: state.modals.modalProps,
  user: state.user,
  modelExport: state.modelExports.byIds[state.modelExports.allIds[0]],
  lng:  state.locale.lng
});

const mapDispatchToProps = dispatch => ({
  openModal: payload => dispatch(actions.openModal(payload)),
  closeModal: () => dispatch(actions.closeModal()),
  confirmModal: () => dispatch(actions.confirmModal()),
  createModelExport: payload => dispatch(actions.createModelExport(payload)),
  updateUserHasVisited: payload =>
    dispatch(actions.updateUserHasVisited(payload)),
  openPasswordResetModal: () =>
    dispatch(
      actions.openModal({
        modalType: MODAL_TYPES.PASSWORD_RESET
      })
    )
});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(RootModal);

const withTranslationComponent = withTranslation(["editor", "modals", "signin", "signup","common"])(connectedComponent);
export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/RootModal.js